import {Component} from 'react'
import {v4 as uuidv4} from 'uuid'
import PasswordItem from '../PasswordItem'
import './index.css'

const initialContainerBackgroundClassNames = [
  'amber',
  'blue',
  'orange',
  'purple',
  'red',
  'green',
  'teal',
]

class PasswordManager extends Component {
  state = {
    passwordsList: [],
    websiteInput: '',
    usernameInput: '',
    passwordInput: '',
    searchInput: '',
    isPasswordVisible: false,
  }

  onChangeWebsiteInput = event => {
    this.setState({websiteInput: event.target.value})
  }

  onChangeUsernameInput = event => {
    this.setState({usernameInput: event.target.value})
  }

  onChangePasswordInput = event => {
    this.setState({passwordInput: event.target.value})
  }

  onChangeSearchInput = event => {
    this.setState({searchInput: event.target.value})
  }

  onToggleVisibility = () => {
    this.setState(prevState => ({
      isPasswordVisible: !prevState.isPasswordVisible,
    }))
  }

  onAddPasswordItem = event => {
    event.preventDefault()
    const {websiteInput, usernameInput, passwordInput} = this.state

    if (
      websiteInput.trim() === '' ||
      usernameInput.trim() === '' ||
      passwordInput.trim() === ''
    ) {
      return
    }

    const backgroundIndex = Math.floor(
      Math.random() * initialContainerBackgroundClassNames.length,
    )
    const initialClassName =
      initialContainerBackgroundClassNames[backgroundIndex]

    const newPasswordItem = {
      id: uuidv4(),
      website: websiteInput,
      username: usernameInput,
      password: passwordInput,
      initialClassName,
    }

    this.setState(prevState => ({
      passwordsList: [...prevState.passwordsList, newPasswordItem],
      websiteInput: '',
      usernameInput: '',
      passwordInput: '',
    }))
  }

  deletePasswordItem = id => {
    this.setState(prevState => ({
      passwordsList: prevState.passwordsList.filter(item => item.id !== id),
    }))
  }

  render() {
    const {
      passwordsList,
      websiteInput,
      usernameInput,
      passwordInput,
      searchInput,
      isPasswordVisible,
    } = this.state

    const searchResults = passwordsList.filter(eachItem =>
      eachItem.website.toLowerCase().includes(searchInput.toLowerCase()),
    )

    const passwordsCount = searchResults.length
    const isHistoryEmpty = passwordsCount === 0

    return (
      <div className="app-container">
        <div className="password-manager-content">
          <img
            src="https://assets.ccbp.in/frontend/react-js/password-manager-logo-img.png"
            alt="app logo"
            className="app-logo"
          />
          <div className="top-section">
            <form className="password-form" onSubmit={this.onAddPasswordItem}>
              <h1 className="form-heading">Add New Password</h1>
              <div className="input-container">
                <div className="icon-bg">
                  <img
                    src="https://assets.ccbp.in/frontend/react-js/password-manager-website-img.png"
                    alt="website"
                    className="input-icon"
                  />
                </div>
                <input
                  type="text"
                  className="input-field"
                  placeholder="Enter Website"
                  value={websiteInput}
                  onChange={this.onChangeWebsiteInput}
                />
              </div>
              <div className="input-container">
                <div className="icon-bg">
                  <img
                    src="https://assets.ccbp.in/frontend/react-js/password-manager-username-img.png"
                    alt="username"
                    className="input-icon"
                  />
                </div>
                <input
                  type="text"
                  className="input-field"
                  placeholder="Enter Username"
                  value={usernameInput}
                  onChange={this.onChangeUsernameInput}
                />
              </div>
              <div className="input-container">
                <div className="icon-bg">
                  <img
                    src="https://assets.ccbp.in/frontend/react-js/password-manager-password-img.png"
                    alt="password"
                    className="input-icon"
                  />
                </div>
                <input
                  type="password"
                  className="input-field"
                  placeholder="Enter Password"
                  value={passwordInput}
                  onChange={this.onChangePasswordInput}
                />
              </div>
              <button type="submit" className="add-btn">
                Add
              </button>
            </form>
            <div className="image-container-lg">
              <img
                src="https://assets.ccbp.in/frontend/react-js/password-manager-lg-img.png"
                alt="password manager"
                className="banner-img"
              />
            </div>
          </div>

          <div className="bottom-section">
            <div className="bottom-header">
              <div className="count-container">
                <h1 className="passwords-heading">Your Passwords</h1>
                <p className="count-badge">{passwordsCount}</p>
              </div>
              <div className="search-container">
                <div className="search-icon-bg">
                  <img
                    src="https://assets.ccbp.in/frontend/react-js/password-manager-search-img.png"
                    alt="search"
                    className="search-icon"
                  />
                </div>
                <input
                  type="search"
                  className="search-input"
                  placeholder="Search"
                  value={searchInput}
                  onChange={this.onChangeSearchInput}
                />
              </div>
            </div>
            <hr className="divider" />
            <div className="checkbox-container">
              <input
                type="checkbox"
                id="showPassword"
                className="checkbox"
                checked={isPasswordVisible}
                onChange={this.onToggleVisibility}
              />
              <label htmlFor="showPassword" className="checkbox-label">
                Show Passwords
              </label>
            </div>

            {isHistoryEmpty ? (
              <div className="no-passwords-container">
                <img
                  src="https://assets.ccbp.in/frontend/react-js/no-passwords-img.png"
                  alt="no passwords"
                  className="no-passwords-img"
                />
                <p className="no-passwords-heading">No Passwords</p>
              </div>
            ) : (
              <ul className="passwords-list">
                {searchResults.map(eachItem => (
                  <PasswordItem
                    key={eachItem.id}
                    passwordDetails={eachItem}
                    isPasswordVisible={isPasswordVisible}
                    deletePasswordItem={this.deletePasswordItem}
                  />
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default PasswordManager
